// European Countries width identical address format
export const EU_COMMON_ADDR_FORMAT_COUNTRIES = ['CHE', 'FRA', 'DEU', 'NLD', 'SWE']

// Countries width North American Address Format
export const NA_COMMON_ADDR_FORMAT_COUNTRIES = ['USA', 'CAN', 'AUS']

export type FormConfigItem = {
  field: string
  label: string
  colSpan: number
  required: boolean
}

const defaultFormConfig: FormConfigItem[] = [
  {
    field: 'address_line_one',
    label: 'vendor.apply_candidate.address_line_1',
    colSpan: 2,
    required: true
  },
  {
    field: 'address_line_two',
    label: 'vendor.apply_candidate.address_line_2',
    colSpan: 2,
    required: false
  },
  {
    field: 'address_line_three',
    label: 'vendor.apply_candidate.address_line_3',
    colSpan: 2,
    required: false
  },
  {
    field: 'state',
    label: 'vendor.apply_candidate.subdivision',
    colSpan: 2,
    required: false
  },
  {
    field: 'city',
    label: 'vendor.apply_candidate.city',
    colSpan: 1,
    required: true
  },
  {
    field: 'county',
    label: 'vendor.apply_candidate.county',
    colSpan: 1,
    required: false
  },
  {
    field: 'neighborhood',
    label: 'vendor.apply_candidate.neighborhood',
    colSpan: 1,
    required: false
  },
  {
    field: 'zip',
    label: 'vendor.apply_candidate.postal_code',
    colSpan: 1,
    required: true
  }
]

const formConfig: Record<string, FormConfigItem[]> = Object.freeze({
  USA: [
    {
      field: 'address_line_one',
      label: 'vendor.apply_candidate.address_line_1',
      colSpan: 2,
      required: true
    },
    {
      field: 'address_line_two',
      label: 'vendor.apply_candidate.address_line_2',
      colSpan: 2,
      required: false
    },
    {
      field: 'state',
      label: 'vendor.apply_candidate.state',
      colSpan: 1,
      required: true
    },
    {
      field: 'city',
      label: 'vendor.apply_candidate.city',
      colSpan: 1,
      required: true
    },
    {
      field: 'county',
      label: 'vendor.apply_candidate.county',
      colSpan: 1,
      required: false
    },
    {
      field: 'zip',
      label: 'vendor.apply_candidate.zip_code',
      placeholder: '12345',
      colSpan: 1,
      required: true
    }
  ],
  AUS: [
    {
      field: 'address_line_one',
      label: 'vendor.apply_candidate.address_line_1',
      colSpan: 2,
      required: true
    },
    {
      field: 'address_line_two',
      label: 'vendor.apply_candidate.address_line_2',
      colSpan: 2,
      required: false
    },
    {
      field: 'state',
      label: 'vendor.apply_candidate.state_slash_territory',
      colSpan: 2,
      required: true
    },
    {
      field: 'city',
      label: 'vendor.apply_candidate.city',
      colSpan: 1,
      required: true
    },
    {
      field: 'zip',
      label: 'vendor.apply_candidate.zip_code',
      placeholder: '1000',
      colSpan: 1,
      required: true
    }
  ],
  CAN: [
    {
      field: 'address_line_one',
      label: 'vendor.apply_candidate.address_line_1',
      colSpan: 2,
      required: true
    },
    {
      field: 'address_line_two',
      label: 'vendor.apply_candidate.address_line_2',
      colSpan: 2,
      required: false
    },
    {
      field: 'state',
      label: 'vendor.apply_candidate.province_slash_territory',
      colSpan: 2,
      required: true
    },
    {
      field: 'city',
      label: 'vendor.apply_candidate.city',
      colSpan: 1,
      required: false
    },
    {
      field: 'zip',
      label: 'vendor.apply_candidate.postal_code',
      placeholder: 'A1A 1A1',
      colSpan: 1,
      required: true
    }
  ],
  FRA: [
    {
      field: 'address_line_one',
      label: 'vendor.apply_candidate.address_line_1',
      colSpan: 2,
      required: true
    },
    {
      field: 'address_line_two',
      label: 'vendor.apply_candidate.address_line_2',
      colSpan: 2,
      required: false
    },
    {
      field: 'address_line_three',
      label: 'vendor.apply_candidate.address_line_3',
      colSpan: 2,
      required: false
    },
    {
      field: 'state',
      label: 'vendor.apply_candidate.department_slash_region',
      colSpan: 2,
      required: false
    },
    {
      field: 'city',
      label: 'vendor.apply_candidate.city',
      colSpan: 1,
      required: true
    },
    {
      field: 'zip',
      label: 'vendor.apply_candidate.postal_code',
      placeholder: '12345',
      colSpan: 1,
      required: true
    }
  ],
  DEU: [
    {
      field: 'address_line_one',
      label: 'vendor.apply_candidate.address_line_1',
      colSpan: 2,
      required: true
    },
    {
      field: 'address_line_two',
      label: 'vendor.apply_candidate.address_line_2',
      colSpan: 2,
      required: false
    },
    {
      field: 'address_line_three',
      label: 'vendor.apply_candidate.address_line_3',
      colSpan: 2,
      required: false
    },
    {
      field: 'state',
      label: 'vendor.apply_candidate.land_slash_state',
      colSpan: 2,
      required: false
    },
    {
      field: 'city',
      label: 'vendor.apply_candidate.town_slash_city',
      colSpan: 1,
      required: true
    },
    {
      field: 'zip',
      label: 'vendor.apply_candidate.postal_code',
      placeholder: '12345',
      colSpan: 1,
      required: true
    }
  ],
  IND: [
    {
      field: 'address_line_one',
      label: 'vendor.apply_candidate.address_line_1',
      colSpan: 2,
      required: true
    },
    {
      field: 'address_line_two',
      label: 'vendor.apply_candidate.address_line_2',
      colSpan: 2,
      required: false
    },
    {
      field: 'address_line_three',
      label: 'vendor.apply_candidate.address_line_3',
      colSpan: 2,
      required: false
    },
    {
      field: 'state',
      label: 'vendor.apply_candidate.state',
      colSpan: 1,
      required: false
    },
    {
      field: 'city',
      label: 'vendor.apply_candidate.town_slash_city',
      colSpan: 1,
      required: true
    },
    {
      field: 'zip',
      label: 'vendor.apply_candidate.pin_code',
      placeholder: '111111',
      colSpan: 1,
      required: true
    }
  ],
  MEX: [
    {
      field: 'address_line_one',
      label: 'vendor.apply_candidate.address_line_1',
      colSpan: 2,
      required: true
    },
    {
      field: 'address_line_two',
      label: 'vendor.apply_candidate.address_line_2',
      colSpan: 2,
      required: false
    },
    {
      field: 'state',
      label: 'vendor.apply_candidate.province_slash_state',
      colSpan: 1,
      required: false
    },
    {
      field: 'city',
      label: 'vendor.apply_candidate.city',
      colSpan: 1,
      required: true
    },
    {
      field: 'neighborhood',
      label: 'vendor.apply_candidate.neighborhood',
      colSpan: 1,
      required: false
    },
    {
      field: 'zip',
      label: 'vendor.apply_candidate.postal_code',
      placeholder: '01020',
      colSpan: 1,
      required: true
    }
  ],
  NLD: [
    {
      field: 'address_line_one',
      label: 'vendor.apply_candidate.address_line_1',
      colSpan: 2,
      required: true
    },
    {
      field: 'address_line_two',
      label: 'vendor.apply_candidate.address_line_2',
      colSpan: 2,
      required: false
    },
    {
      field: 'state',
      label: 'vendor.apply_candidate.province',
      colSpan: 2,
      required: false
    },
    {
      field: 'city',
      label: 'vendor.apply_candidate.town_slash_city',
      colSpan: 1,
      required: true
    },
    {
      field: 'zip',
      label: 'vendor.apply_candidate.postal_code',
      placeholder: '1000ab',
      colSpan: 1,
      required: true
    }
  ],
  SWE: [
    {
      field: 'address_line_one',
      label: 'vendor.apply_candidate.address_line_1',
      colSpan: 2,
      required: true
    },
    {
      field: 'address_line_two',
      label: 'vendor.apply_candidate.address_line_2',
      colSpan: 2,
      required: false
    },
    {
      field: 'state',
      label: 'vendor.apply_candidate.county_slash_state',
      colSpan: 2,
      required: false
    },
    {
      field: 'city',
      label: 'vendor.apply_candidate.town_slash_city',
      colSpan: 1,
      required: true
    },
    {
      field: 'zip',
      label: 'vendor.apply_candidate.postal_code',
      placeholder: '62146',
      colSpan: 1,
      required: true
    }
  ],
  CHE: [
    {
      field: 'address_line_one',
      label: 'vendor.apply_candidate.address_line_1',
      colSpan: 2,
      required: true
    },
    {
      field: 'address_line_two',
      label: 'vendor.apply_candidate.address_line_2',
      colSpan: 2,
      required: false
    },
    {
      field: 'state',
      label: 'vendor.apply_candidate.canton_slash_state',
      colSpan: 2,
      required: false
    },
    {
      field: 'city',
      label: 'vendor.apply_candidate.city',
      colSpan: 1,
      required: true
    },
    {
      field: 'zip',
      label: 'vendor.apply_candidate.postal_code',
      placeholder: '1111',
      colSpan: 1,
      required: true
    }
  ],
  GBR: [
    {
      field: 'address_line_one',
      label: 'vendor.apply_candidate.address_line_1',
      colSpan: 2,
      required: true
    },
    {
      field: 'address_line_two',
      label: 'vendor.apply_candidate.address_line_2',
      colSpan: 2,
      required: false
    },
    {
      field: 'address_line_three',
      label: 'vendor.apply_candidate.address_line_3',
      colSpan: 2,
      required: false
    },
    {
      field: 'state',
      label: 'vendor.apply_candidate.county',
      colSpan: 1,
      required: false
    },
    {
      field: 'city',
      label: 'vendor.apply_candidate.town_slash_city',
      colSpan: 1,
      required: true
    },
    {
      field: 'zip',
      label: 'vendor.apply_candidate.postal_code',
      placeholder: 'AB19XY',
      colSpan: 1,
      required: true
    }
  ],
  BRA: [
    {
      field: 'address_line_one',
      label: 'vendor.apply_candidate.address_line_1',
      colSpan: 2,
      required: true
    },
    {
      field: 'address_line_two',
      label: 'vendor.apply_candidate.address_line_2',
      colSpan: 2,
      required: false
    },
    {
      field: 'address_line_three',
      label: 'vendor.apply_candidate.address_line_3',
      colSpan: 2,
      required: false
    },
    {
      field: 'neighborhood',
      label: 'vendor.apply_candidate.neighborhood',
      colSpan: 2,
      required: false
    },
    {
      field: 'state',
      label: 'vendor.apply_candidate.state',
      colSpan: 1,
      required: true
    },
    {
      field: 'city',
      label: 'vendor.apply_candidate.town_slash_city',
      colSpan: 1,
      required: true
    },
    {
      field: 'zip',
      label: 'vendor.apply_candidate.postal_code',
      placeholder: '12345-123',
      colSpan: 1,
      required: true
    }
  ],
  ISR: [
    {
      field: 'address_line_one',
      label: 'vendor.apply_candidate.address_line_1',
      colSpan: 2,
      required: true
    },
    {
      field: 'address_line_two',
      label: 'vendor.apply_candidate.address_line_2',
      colSpan: 2,
      required: false
    },
    {
      field: 'address_line_three',
      label: 'vendor.apply_candidate.address_line_3',
      colSpan: 2,
      required: false
    },
    {
      field: 'state',
      label: 'vendor.apply_candidate.district',
      colSpan: 2,
      required: false
    },
    {
      field: 'city',
      label: 'vendor.apply_candidate.town_slash_city',
      colSpan: 1,
      required: true
    },
    {
      field: 'zip',
      label: 'vendor.apply_candidate.postal_code',
      placeholder: '1234567',
      colSpan: 1,
      required: true
    }
  ]
})

/**
 * @param {string} countryCode
 * @returns {Array<{
 *   field: string,
 *   label: string,
 *   colspan: number,
 *   placeholder?: string
 * }>}
 */
export const getAddressConfig = (countryCode: string) => {
  return countryCode in formConfig ? formConfig[countryCode] : defaultFormConfig
}
